import React from "react";
import TemplateNewIn from "../template/templateNewIn";

function NewInPage() {

    return (
        <div>
            <TemplateNewIn />
        </div>
    );
}

export default NewInPage;